import React from 'react';
import Hero from './Hero';
import About from '../sections/About/About';
import Experience from '../sections/Experience/Experience';
import Education from '../sections/Education/Education';
import Projects from '../sections/Projects/Projects';
import Skills from '../sections/Skills/Skills';
import Publications from '../sections/Publications/Publications';
import Contact from '../sections/Contact/Contact';
// import UIDemo from './UIDemo'; // DISABLED - UI Demo temporarily disabled
import ScrollToTop from './ScrollToTop';
import Footer from './Footer';
import ParticleBackground from './ParticleBackground';

// Feature flag for new Navigation architecture
// NEW navigation is now DEFAULT (Phase 4.2 complete!)
// Set localStorage.setItem('useNewNav', 'false') to revert to original if needed
const USE_OLD_NAV = localStorage.getItem('useNewNav') === 'false';

const NavigationOld = require('./Navigation').default;
const NavigationNew = require('./Navigation.new').default;
const Navigation = USE_OLD_NAV ? NavigationOld : NavigationNew;

console.log(`[Navigation] Using ${USE_OLD_NAV ? 'OLD (original - fallback)' : 'NEW (refactored - default)'} architecture`);

const AppContent = () => {

  return (
    <div 
      className="min-h-screen transition-all duration-500 relative bg-[var(--bg-light)] dark:bg-[var(--bg-dark)]"
    >
      {/* Animated Particle Background - App-wide */}
      <ParticleBackground />
      
      <Navigation />
      <Hero />
      <About />
      <Experience />
      <Education />
      <Projects />
      <Skills />
      <Publications />
      <Contact />
      {/* <UIDemo /> */} {/* DISABLED - UI Demo temporarily disabled */}
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default AppContent;
